import { IqueryParams, IRegion } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

interface ExportParams extends IqueryParams<{
  region_name?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createRegion = async (name: string) => {
  return apiService.apiRequest<{ name: string }>("post", `regions`, { name });
};

const getRegions = async (queryParams?: IqueryParams<{
  region_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IRegion[]>("get", `regions${query}`);
};

const getRegion = async (region_id: string) => {
  return apiService.apiRequest<IRegion>("get", `regions/${region_id}`);
};

const updateRegion = async (region_id: string, data: { name: string }) => {
  return apiService.apiRequest<IRegion>("put", `regions/${region_id}`, data);
};

const deleteRegion = async (region_id: string) => {
  return apiService.apiRequest<any>("delete", `regions/${region_id}`);
};

const restoreRegion = async (region_id: string) => {
  return apiService.apiRequest<any>("patch", `regions/${region_id}/restore`);
};

const exportRegions = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `regions/export${query}`
  );
};

export const regionApi = {
  createRegion,
  getRegions,
  getRegion,
  updateRegion,
  deleteRegion,
  restoreRegion,
  exportRegions,
};